import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Shopnow from "./pages/Shopnow";
import Combo from "./pages/Combo";
import AboutUs from "./pages/About";
// import Franchise from "./pages/Franchise";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import setAuthToken from "./utils/setAuthToken";
import Profile from "./pages/Profile";
import ProductDetails from "./pages/ProductDetails";
import Checkout from "./pages/Checkout";
import SearchResults from "./pages/SearchResults";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsandConditions";
import RefundPolicy from "./pages/RefundPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import SelectDeliveryLocations from "./pages/DeliveryLocationSelector";
import OrderSuccess from "./pages/OrderSuccess";
import ContactUs from "./pages/Contactus";
import ScrollToTop from "./utils/ScrollToTop";
import NotFound from "./pages/NotFound";
import BulkOrder from "./pages/BulkOrder";

const token = localStorage.getItem("token") || sessionStorage.getItem("token");
if (token) {
  setAuthToken(token);
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/categories/:categorySlug?" element={<Shopnow />} />
        <Route path="/combo_offer" element={<Combo />} />
        <Route path="/aboutus" element={<AboutUs />} />
        {/* <Route path="/franchise" element={<Franchise />} /> */}
        <Route path="/cart" element={<Cart />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/product/:slug" element={<ProductDetails />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/search/:query" element={<SearchResults />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route
          path="/select-delivery-location"
          element={<SelectDeliveryLocations />}
        />
        <Route path="/order-success/:orderId" element={<OrderSuccess />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/bulk-orders" element={<BulkOrder />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
